import scrollTo from '../common/scrollTo'

const fn = {
  init: () => {
    fn.setupNewsList()
  },

  setupNewsList: () => {
    let currentPage = 1
    const PAGE_LENGTH = 8
    const $newsPagination = $('.newsroom-pagination')
    const $newsPaginationMore = $('.newsroom-pagination__more')
    const $newsPaginationLess = $('.newsroom-pagination__less')
    const $newsList = $('.newsroom-list')

    const handleNewsPagination = () => {
      const total = $newsList.find('li').length
      const hiddenIndex = currentPage * PAGE_LENGTH

      if (total > PAGE_LENGTH) {
        $newsList.find('li').each((index, el) => {
          $(el).toggleClass('is-hidden', index >= hiddenIndex)
        })
      }

      const currentCount = $newsList.find('li').not('.is-hidden').length

      $newsPagination
        .find('.newsroom-pagination__current')
        .text(currentCount)
      $newsPagination
        .find('.newsroom-pagination__actions')
        .toggle(total > PAGE_LENGTH)
      $newsPaginationMore.toggle($newsList.find('li.is-hidden').length > 0)
      $newsPaginationLess.toggle(currentPage > 1)
    }

    handleNewsPagination()

    $newsPaginationMore.on('click', () => {
      currentPage = currentPage + 1
      handleNewsPagination()
    })

    $newsPaginationLess.on('click', () => {
      currentPage = 1
      handleNewsPagination()
      scrollTo($newsList[0], 500)
    })
  }
}

export default {
  can: () => $('body').hasClass('pagetype-blog'),
  run: fn.init
}
